import styled from 'styled-components'
import { breakpoint } from '@sketch/global-styles'

export const PlansWrapper = styled.section`
  display: flex;
  flex-direction: column;

  ${breakpoint('sm')`
      flex-direction: row;
  `}

  ${breakpoint('base', 'xs')`
      justify-content: space-around;
  `}
`
